module.exports = __webpack_public_path__ + "media/PAG84-02.b3f83c5b.mp3";